<template>
  <vs-row>
    <vs-col
        vs-w="12"
        class="mt-4"
    >
      <fb-paginacion
          :total="pages"
          :max="10"
          v-model="page"
      />
    </vs-col>
  </vs-row>
</template>
<script>
import FbPaginacion from '@/febos/chile/_vue/componentes/FbPaginacion';

export default {
  name: 'ListPagination',
  props: ['show', 'value', 'pages'],
  components: { FbPaginacion },
  watch: {
    value(newValue) {
      this.page = newValue;
    },
    page(newValue) {
      this.$emit('input', newValue);
      this.$emit('change', newValue);
    }
  },
  data() {
    return {
      page: this.value
    };
  }
};

</script>
